import { createSlice } from '@reduxjs/toolkit';
import { RESET_STATE } from '../actions/authActions';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
    },
    loginFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
    resetState: () => {
      return {
        isAuthenticated: false,
        user: null,
        loading: false,
        error: null,
      };
    },
  },
});

export const { loginRequest, loginSuccess, loginFailure, logout, resetState } = authSlice.actions;
export default authSlice.reducer;
